import { api } from '@/lib/api';

export const medicinesService = {
  async getAll() {
    const { data } = await api.get('/medicines');
    return { data };
  },

  async create(body) {
    const { data } = await api.post('/medicines', body);
    return { data };
  },

  async update(id, body) {
    const { data } = await api.patch(`/medicines/${id}`, body);
    return { data };
  },

  async delete(id) {
    await api.delete(`/medicines/${id}`);
    return { success: true };
  },
};
